import React, { useRef } from 'react';
import FaceSwapIntro from './FaceSwapIntro';
import FaceSwapUpload from './FaceSwapUpload';
import FaceSwapHistory, { FaceSwapHistoryRef } from './FaceSwapHistory';
import FaceSwapHowTo from './FaceSwapHowTo';
import FaceSwapTechFeatures from './FaceSwapTechFeatures';
import './FaceSwapMain.css';

const FaceSwapMain: React.FC = () => {
  // 创建 ref
  const historyRef = useRef<FaceSwapHistoryRef>(null);

  // 定义提交成功后的回调
  const handleTaskSubmitted = () => {
    // 主动触发历史刷新
    historyRef.current?.refetch();
  };

  return (
    <main className="face-swap-main">
      <div className="main-container">
        {/* Feature Intro Section */}
        <div className="feature-intro-section">
          <FaceSwapIntro />
          <FaceSwapUpload onTaskSubmitted={handleTaskSubmitted} />
        </div>
        
        {/* History Section */}
        <FaceSwapHistory ref={historyRef} />
        
        {/* How To Section */}
        <FaceSwapHowTo />
        
        {/* Tech Features Section */}
        <FaceSwapTechFeatures />
      </div>
    </main>
  );
};

export default FaceSwapMain;